import { render } from "./Results.vue?vue&type=template&id=6cb3a94b"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import "./Results.vue?vue&type=style&index=0&id=6cb3a94b&lang=scss"

import exportComponent from "/Users/jeromebart/sites/cdm-quiz/cite-des-metiers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__